import { Node as ProsemirrorNode } from "prosemirror-model";
import { EditorState } from "prosemirror-state";

export function isEmptyContent(
	editorState: EditorState
): boolean {
	const doc: ProsemirrorNode = editorState.doc;

	return doc.content.size === 0;
}